module.exports = __webpack_public_path__ + "img/bg-karolina-miekina.1c07a377.jpg";